// extracted by mini-css-extract-plugin
export default {"cta":"RH-z","disabled":"SH-z"};